<template>
  <div class="bar-container">
    <div class="bar-container-item">
      <img
        @click="href('download')"
        src="@/accesst/index/tpkz-img.jpg"
        alt=""
        srcset=""
      />
      <div>同屏控制</div>
    </div>
    <div class="bar-container-item">
      <img
        @click="href('userMemager')"
        src="@/accesst/index/yhbd-img.png"
        alt=""
        srcset=""
      />
      <div>用户管理</div>
    </div>
    <div @click="gotoBind" class="bar-container-item">
      <!-- <img @click="href('deviceBindNew')" src="@/accesst/index/share.png" alt="" srcset=""> -->
      <img src="@/accesst/index/share.png" alt="" srcset="" />
      <div>设备绑定</div>
    </div>
    <div class="bar-container-item">
      <img
        @click="href('device')"
        src="@/accesst/index/setting.png"
        alt=""
        srcset=""
      />
      <div>设备管理</div>
    </div>
    <div class="bar-container-item">
      <img
        @click="href('goods')"
        src="@/accesst/index/jifen.png"
        alt=""
        srcset=""
      />
      <div>积分兑换</div>
    </div>
    <div class="bar-container-item">
      <img
        @click="href('user')"
        src="@/accesst/index/user.png"
        alt=""
        srcset=""
      />
      <div>个人信息</div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    gotoBind() {
      window.location.href = "/deviceBind"; // 强制刷新页面，保证签名URL一致
    },
    href(name) {
      if (name == "download") {
        window.location.href = "/download/download.html";
      } else {
        this.$router.push({
          name,
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.bar-container {
  display: flex;
  align-items: center;
  // justify-content: space-between;
  flex-wrap: wrap;

  .bar-container-item {
    height: 1.5rem;
    width: 25%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 0.27rem;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #000000;
    text-align: center;

    img {
      width: 0.77rem;
      height: 0.77rem;
      display: block;
      margin: 0 auto 0.19rem;
    }
  }
}
</style>
